import React, { useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
} from "@mui/material";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";

export default function StockverificationBillingTable({ data, loadTempData }) {
  const [barcode, setBarcode] = useState("");
  const outletId = Number(localStorage.getItem("outlet_id"));
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const scanLockRef = useRef(false); // true while a scan request is running

  const handleBarcodeScan = async (e) => {
    if (e.key !== "Enter") return;
    if (scanLockRef.current) return;

    const code = barcode.trim();
    if (!code) return;

    scanLockRef.current = true;
    try {
      const item = await axios.get(`/v1/itemdetails/barcode/issue/${code}`);
      const p = item.data;

      if (!p) {
        dispatch(setSnackbar(true, "error", "Item not found"));
        setBarcode("");
        return;
      }

      await axios.post("/v1/stock_verify/scan", {
        barcode: code,
        outlet_id: outletId,
        // partycode: outletId,
        partycode: p.partycode || null,

        prodid: p.prod_id,
        pro_code: p.pro_code,
        description: p.pro_description,
        mrp: p.mrp,
        gst_per: p.gst,
        rate: p.sale_rate,
        dis_per: p.discount,
        qty: 1,
        gst_amt: p.gst_amt,
        amount: p.amount,
        company_id: p.company_id,
      });

      dispatch(setSnackbar(true, "success", "Barcode scanned"));
      setBarcode("");
      await loadTempData();

      setTimeout(() => inputRef.current?.focus(), 50);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.errors?.[0]?.message ||
        "Scan Failed";

      dispatch(setSnackbar(true, "error", msg));

      setBarcode("");
      await loadTempData();
      setTimeout(() => inputRef.current?.focus(), 50);
    } finally {
      scanLockRef.current = false;
    }
  };

  const headerStyle = {
    backgroundColor: "#c266d3",
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center",
  };

  return (
    <Box sx={{ padding: 2 }}>
      {/* SCAN BOX */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <TextField
          placeholder="Scan Barcode"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          onKeyDown={handleBarcodeScan}
          size="small"
          sx={{ width: 250 }}
          inputRef={inputRef}
        />
      </Box>

      <TableContainer component={Paper} sx={{height:590}}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={headerStyle}>Sno</TableCell>
              <TableCell sx={headerStyle}>Barcode</TableCell>
              <TableCell sx={headerStyle}>Product Code</TableCell>
              <TableCell sx={headerStyle}>Description</TableCell>
              <TableCell sx={headerStyle}>MRP</TableCell>
              <TableCell sx={headerStyle}>GST%</TableCell>
              <TableCell sx={headerStyle}>Rate</TableCell>
              <TableCell sx={headerStyle}>Qty</TableCell>
              {/* <TableCell sx={headerStyle}>Count</TableCell> */}
              <TableCell sx={headerStyle}>GST</TableCell>
              <TableCell sx={headerStyle}>Amount</TableCell>
              <TableCell sx={headerStyle}>Verified</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.map((row, index) => (
              <TableRow key={row.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.barcode}</TableCell>
                <TableCell>{row.pro_code}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.mrp}</TableCell>
                <TableCell>{row.gst_per}</TableCell>
                <TableCell>{row.rate}</TableCell>
                <TableCell>{row.qty}</TableCell>
                {/* <TableCell>
                  {Math.max((row.original_qty || 1) - (row.scanned_count || 1), 0)}
                </TableCell> */}
                {/* <TableCell>{row.gst_amt}</TableCell> */}
                <TableCell>
                  {(
                    (Number(row.rate) *
                      Number(row.qty || 1) *
                      Number(row.gst_per || 0)) /
                    100
                  ).toFixed(2)}
                </TableCell>
                {/* <TableCell>{row.amount}</TableCell> */}
                <TableCell>
                  {(Number(row.rate) * Number(row.qty || 1)).toFixed(2)}
                </TableCell>
                {/* <TableCell align="center">
                  {row.is_verified ? (
                    <span style={{ color: "green", fontWeight: 600 }}>
                      Verified
                    </span>
                  ) : (
                    <span style={{ color: "orange", fontWeight: 600 }}>
                      Pending
                    </span>
                  )}
                </TableCell> */}
                <TableCell align="center">
                 {row.is_verified === true ? (
           <span style={{ color: "green", fontWeight: 600 }}>
            Verified
         </span>
         ) : (
    <span style={{ color: "orange", fontWeight: 600 }}>
             Pending
         </span>
        )}
      </TableCell>

              </TableRow>
            ))}

            {(!data || data.length === 0) && (
              <TableRow>
                <TableCell colSpan={11} style={{ textAlign: "center" }}>
                  No items scanned yet
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
